/**
 * 파일명 : hom0101p.tsx
 * 설명 : 사업장관리 탭 사업장 등록 화면
 * 수정내역
 ******************************************************
 * Version    수정일자      수정자             수정내용      
 ******************************************************
 * 1.0       2023-04-07   김세희/백승준 외 1명 최초작성
 * 1.1       2023-05-12   장용, 황은택
 * 1.2       2024-04-12    기라성              주소 다음API로 등록하는 것으로 수정 
 */

/******************************************************
 * Import 영역  
 *****************************************************/
/* React */
import React, {useState} from 'react';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import DaumPost from '../../components/DaumPost';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Hom0101pAction } from '../../../redux/slice/hom/hom0101p_slice';
import { IAttachFileItemState } from '../../../redux/models/hom/hom0101p_model';

/* AntD */
import { Input, Layout, Row, Col, Space, Button, Descriptions, Upload, Select, Table} from 'antd';

/* 업무 */
import * as commonProxy from 'libs/CommonProxy';
import * as common from 'libs/common';

/************************************************
 * 전역변수 선언영역
 ************************************************/

const Hom0101p = (props:any) => {
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */
    const dispatch = useAppDispatch();
    const businessItem    = useAppSelector((state) => state.Hom0101p.businessItem);
    const attachFileItems = useAppSelector((state) => state.Hom0101p.attachFileItems);
    const fileList        = useAppSelector((state) => state.Hom0101p.fileList);

    const { Search } = Input;
    const [isDaumPost, setIsDaumPost] = useState(false);
    /************************************************
     * Render 변수 선언 및 셋팅영역
     ************************************************/

    /* AntD */
    const { Content } = Layout;

    React.useEffect(() => {
        getMaxOrd();

        return () => {
            dispatch(Hom0101pAction.initState());
        }
    }, []);

    /**
     * 기능 : 파일들을 Back으로 보내 업로드 한다.
     * param :
     * return : None
     */
    const requestUploadFiles = (options:any) => {
        common.uploadFile(fileList, {
            sourceDcd: '04',
            sourceId: 0,
            success: (response:any) => {
                if(typeof options.callback === 'function'){
                    options.callback(response);
                }
            },
        });
    }

    const getMaxOrd = () => {
        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        const requestData = {
            companyInstCd : props.companyInstCd
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRHOMR0102',
            success: (responseData:any) => {    
                if (!common.isEmptyString(props.companyInstCd)) {
                    dispatch(Hom0101pAction.setBusinessItem({ ...responseData.businessItems, inqOrdrMax : responseData.inqOrdrMax + 1 }));
                    dispatch(Hom0101pAction.setAttachFileItems(responseData.attachFileItems));
                } else {
                    const inqInstCdrMax = responseData.inqInstCdrMax + 1;
                    var companyInstCd = common.lpad(inqInstCdrMax, 4, '0');
                    dispatch(Hom0101pAction.setBusinessItem({ ...businessItem, inqOrdr: responseData.inqOrdrMax + 1, inqOrdrMax: responseData.inqOrdrMax + 1, companyInstCd: companyInstCd }));
                }
            },
        });
    }

    /************************************************
     * 이벤트 함수 영역
     ************************************************/
	/**
     * 기능 : 저장버튼 클릭 이벤트
     * 설명 : 등록/수정
     * param : 
     * return : None
     */

    const btnSave_onClick = () => {        
        /* 변수선언 및 셋팅 영역 */
        if(fileList && fileList.length > 0){  // 파일이 있는 경우 (파일업로드 후 게시글 등록 진행)
            requestUploadFiles({
                callback : (data:any) => {      
                    const requestData = { ...businessItem, fileItems : data.fileItems };  // 입력파라미터
                    commonProxy.callAsyncSvc(requestData, {
                        txCd: 'TRHOMS0101',
                        success: (responseData:any) => {    
                            const attachFileItems = responseData.attachFileItems;

                            dispatch(Hom0101pAction.setBusinessItem(responseData.businessItems));
                            dispatch(Hom0101pAction.setAttachFileItems(attachFileItems));

                            const param = {
                                title : '위드정보 확인',
                                contents: '정상적으로 처리되었습니다.',
                            };
        
                            common.openAlert(param);
                        },
                    });
                }
            });
        } else {
            const requestData = { ...businessItem};  // 입력파라미터
            commonProxy.callAsyncSvc(requestData, {
                txCd: 'TRHOMS0101',
                success: (responseData:any) => {
                    dispatch(Hom0101pAction.setBusinessItem(responseData.businessItems));

                    const param = {
                        title : '위드정보 확인',
                        contents: '정상적으로 처리되었습니다.',
                    };

                    common.openAlert(param);
                },
            });
        }
    };

    /**
     * 기능 : 삭제버튼 클릭 이벤트
     * 설명 : 삭제
     * param : 
     * return : None
     */
    const btnDelete_onClick = () => {
        /* 변수선언 및 셋팅 영역 */
        const requestData = { ...businessItem};  // 입력파라미터
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRHOMD0101',
            success: (responseData:any) => {
                dispatch(Hom0101pAction.setBusinessItem(responseData.businessItem));

                const param = {
                    title : '위드정보 확인',
                    contents: '정상적으로 처리되었습니다.',
                };

                common.openAlert(param);
            },
        });
    };

	/**
     * 기능 : 화면 닫기
     * 설명 : 화면 닫기
     * param : 
     * return : None
     */
    const btnClose_onClick = () => {
        props.cancel();
    }

	/**
     * 기능 : 값 변경 이벤트
     * 설명 : 입력컴포넌트
     * param : 
     * return : None
     */
    const inputOnChange = React.useCallback((e:any) => {
        const newBusinessItem = {...businessItem, [e.currentTarget.name] : e.currentTarget.value};
        dispatch(Hom0101pAction.setBusinessItem(newBusinessItem));
    }, [businessItem]);

    /**
     * 기능 : 값 변경 이벤트
     * 설명 : 셀렉컴포넌트
     * param : 
     * return : None
     */
    const handleChangeYN = React.useCallback((e:string) => {
        dispatch(Hom0101pAction.setBusinessItem({ ...businessItem, useYn: e }));
    }, [businessItem]);


    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = (e:any) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnSave': {
                btnSave_onClick();
                break;
            }
            
            case 'btnDelete': {
                btnDelete_onClick();
                break;
            }

            case 'btnClose': {
                btnClose_onClick();
                console.log()
                break;
            }
            
            case 'btnMgr': {
                const item = { ...businessItem, managerEmpNo: '', managerEmpNm: '' };
                dispatch({type : 'SET_STATE', data_node : 'businessItem', value : item});
                const callback = (data:any) => {
                    if(data){   
                        dispatch(Hom0101pAction.setBusinessItem({ ...businessItem, managerEmpNo: data.mngrEmpNo, managerEmpNm: data.mngrUserNm }));
                    }
                }

                const params:any = {};
                params.title = '관리자등록';
                params.popupId = 'com0101p3';
                params.accept = callback;
                params.width = 1100;
                common.openPopup(params);
                break;
            }
            default:
        }
    };

    /** 
        * 기능 : antd dummy 업로드 흐름 관리
        * param : onSuccess
        * return : none
        */
    const dummyRequest = ({ file, onSuccess }:any) => {  	// 업로드 흐름 관리
        setTimeout(() => {
            if (fileList.filter((e:any) => {
                return e.name === file.name;
            }).length < 1) {
                onSuccess('ok');
            }
        }, 0);
    };

    /************************************************
     * 개발자함수 영역
     ************************************************/
    /*ordr체크*/
    const onBlur_ORDR = () =>{
        const max = businessItem.inqOrdrMax;
        const min = 0;

        if (businessItem.inqOrdr === min || businessItem.inqOrdr > max) {
            const param = {
                title: '위드정보 확인',
                contents: '현재 마지막 노출 번호는 '+ max +' 입니다.',
                accept : () => dispatch(Hom0101pAction.setBusinessItem({ ...businessItem, inqOrdr: max }))
            };
            common.openInfo(param);
            return false;

        }
    }

    /**
     * 기능 : 선택한 파일중 done인 파일을 fileList에 추가한다.
     * param :
     * return : None
     */
     const selectFile_onChange = (info:any) => {
        switch (info.file.status) {
            case 'done':
                const grdFile = {fileNm : info.file.originFileObj.name, orginFileNm : info.file.originFileObj.name};
                dispatch(Hom0101pAction.setFileList([info.file.originFileObj]));
                dispatch(Hom0101pAction.setAttachFileItems([grdFile]));
                break;

            default:
                break;
        }
    }

    /**
     * 기능 : upload버튼의 기능 할당
     * param :
     * return : None
     */
    /* File Upload Options */
    const uplodaProps = {
        onChange: selectFile_onChange,
        multiple: false,                  // 파일 다중 선택
        showUploadList: false, 		     // 업로드된 파일 리스트 보기
    };

    /**
     * 기능 : 업로드 전에 선택된 파일을 세팅한다.  
     * param : 
     */
    const beforeUpload = (file:any, fileList:any[]) => {
        dispatch(Hom0101pAction.setAttachFileItems([]));
        dispatch(Hom0101pAction.setFileList([]));

        // 유효성 검사
        if(file.size > 50 * 1024 * 1024) {          
            const param = {
                title: '위드정보 확인',
                contents: '50MB 이하의 파일만 첨부할 수 있습니다.',
            };
            common.openInfo(param);
            return false;
        }

        if(file.type.substr(0, file.type.indexOf('/')) !== 'image') {
            const param = {
                title: '위드정보 확인',
                contents: '이미지 파일만 첨부할 수 있습니다.',
            };
            common.openInfo(param);
            return false;
        }
    }

    /* Table Columns */
    const columnsAttachFiles = React.useCallback(() => {
        const arr:any = [
            {
                key: 'action',
                render : (record:IAttachFileItemState) =>{
                    if(record.id > 0){
                        return <Button name='btn_showDetail' className='link-button' type='link' size='small' onClick={(_:any) => common.downloadFile(record.id)}>{record.orginFileNm}</Button>
                    }else{
                        return record.orginFileNm;
                    }
                },
                align: 'left',
                width: '100px',
            },
            {
                key: 'orginFileNm',
                render : (record:IAttachFileItemState) =>{
                    if (record.id < 1 || businessItem.id < 1 ) {
                        return <Button name='btn_del' icon={<DeleteOutlined/>} className='link-button' size='small' onClick={() => {
                            dispatch(Hom0101pAction.setAttachFileItems([]));
                            dispatch(Hom0101pAction.setFileList([]));
                        }}></Button>
                    } else {
                        return null;
                    }
                },
                align: 'center',
                width: '5%',
            },
        ]
        return arr;
    }, []);

    // 우편번호 찾기 번튼 클릭(팝업Open)
    const addrSearch = () => {
        setIsDaumPost(true);
    }

    // 우편번호 선택 완료
    const handleComplete = (data:any) => {
        // 주소 셋팅
        dispatch(Hom0101pAction.setBusinessItem({ ...businessItem, companyPostNo : data.zonecode, companyAddr : data.address }));
        setIsDaumPost(false);
    }

    /* 노출여부 셀렉박스 */
    const selectList = ['Y', 'N'];
    const { Option }     = Select;

    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Space direction='vertical' size='middle'>
                    <Descriptions bordered column={2} size='small'>
                        <Descriptions.Item label='* 기관코드' labelStyle={{width:110}} span={1}>
                            <Input id='inputCompanyInstCd' name='companyInstCd' onChange={inputOnChange} value={businessItem.companyInstCd} readOnly/>
                        </Descriptions.Item>
                        <Descriptions.Item label='* 기관명' labelStyle={{width:110}} span={2}>
                            <Input id='inputInstNm' name='instNm' onChange={inputOnChange} value={businessItem.instNm}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='* 이메일'>
                            <Input id='inputEmail' name='email' onChange={inputOnChange} value={businessItem.email}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='* 연락처'>
                            <Input id='inputPoneNumber' name='poneNumber' onChange={inputOnChange} value={businessItem.poneNumber}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='* 팩스번호'>
                            <Input id='inputFaxNumber' name='faxNumber' onChange={inputOnChange} value={businessItem.faxNumber}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='* 관리자명' labelStyle={{width:110}}>
                            <Row>
                            {businessItem.managerEmpNo ?
                            <Col style={{marginRight: '10px'}}>
                                <Descriptions.Item  key={businessItem.managerEmpNo}>{businessItem.managerEmpNm} </Descriptions.Item>
                            </Col> : null}
                        <Space>
                            <Col>
                                    <Button
                                        size='small'
                                        name='btnMgr'
                                        className='background-color-default-button'
                                        onClick={onClick}>관리자선택
                                    </Button>

                                </Col></Space>
                            </Row>
                        </Descriptions.Item>
                        <Descriptions.Item label='* 노출여부' labelStyle={{paddingRight: '22px'}}>
                            <Select
                                id='inputUseYn' 
                                defaultValue={businessItem.useYn}
                                value={businessItem.useYn}
                                onChange={handleChangeYN}
                                style={{ width: 120 }}
                            >
                                {selectList.map((e) => (
                                    <Option value={e} key={e}>{(e === 'Y')? '노출' : '비노출'}</Option>
                                ))}
                            </Select>
                        </Descriptions.Item>
                        <Descriptions.Item label='* 노출순서'>
                            <Input id='inputInqOrdr' type='number' name='inqOrdr' onBlur={onBlur_ORDR} onChange={inputOnChange} value={businessItem.inqOrdr}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='대표자명'>
                            <Input id='inputrepreNm' name='repreNm' onChange={inputOnChange} value={businessItem.repreNm}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='설립일자'>
                            <Input id='inputfndnDt' name='fndnDt' onChange={inputOnChange} value={businessItem.fndnDt}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='업종'>
                            <Input id='inputbizTpNm' name='bizTpNm' onChange={inputOnChange} value={businessItem.bizTpNm}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='* 주소' span={3}>
                            <Row>
                                <Space>
                                    <Search id='companyPostNo'  style={{width : '200px'}} placeholder='우편번호' readOnly onSearch={addrSearch} value={businessItem.companyPostNo} enterButton title='우편번호'/>
                                    {isDaumPost && (
                                        <DaumPost onComplete={handleComplete} />
                                    )} 
                                    <Input readOnly value={businessItem.companyAddr} style={{width : '362px'}}/>
                            
                                </Space>
                            </Row>
                            <Input name='companyDtlAddr' style={{width : '570px'}} placeholder='상세주소' value={businessItem.companyDtlAddr} onChange={inputOnChange} maxLength={500} title='상세주소' />
                        </Descriptions.Item>
                    </Descriptions>
                </Space>
                <Row>
                    <Col>
                        <Space size='small'>
                            <Col>
                                <Descriptions.Item label='파일첨부' span={2}>
                                    <Upload
                                        {...uplodaProps}
                                        id='btnUpload'
                                        name='btnUpload'
                                        beforeUpload={beforeUpload}
                                        customRequest={dummyRequest}>
                                        <Button size='small' icon={<UploadOutlined/>}>파일첨부</Button>
                                    </Upload>
                                </Descriptions.Item>
                            </Col>
                            <Col style={{marginTop:7}}>
                                <Table 
                                    dataSource={attachFileItems}
                                    columns={columnsAttachFiles()}
                                    size='small'
                                    style={{width:'100%', height: '50px'}}
                                    pagination={false}
                                    showHeader={false}
                                    locale={{ emptyText: '사업장 이미지가 없습니다.' }}
                                />
                            </Col>
                        </Space>
                    </Col> 
                </Row>
                <Row justify='center'>
                    <Col>
                        <Space direction='horizontal' size='small'>
                            <Button
                                name='btnSave'
                                className='background-color-primary-button'
                                onClick={onClick}
                                disabled={!common.isAdmin()}
                            >
                                저장
                            </Button>
                            <Button
                                name='btnDelete'
                                className='background-color-primary-button'
                                onClick={onClick}
                                disabled={!common.isAdmin()}
                            >
                                삭제
                            </Button>
                            <Button
                                name='btnClose'
                                className='background-color-default-button'
                                onClick={onClick}
                            >
                                닫기
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}

export default Hom0101p;